import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_v_progress_circular, {
          key: 0,
          indeterminate: "",
          color: "primary",
          class: "mr-3"
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_v_list, {
      subheader: "",
      lines: "two"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bankAccounts, (ba, i) => {
          return (_openBlock(), _createBlock(_component_v_list_item, {
            key: i,
            class: _normalizeClass(_ctx.getBankAccountItemClass(ba.id)),
            onClick: _withModifiers(($event: any) => (_ctx.selectBankAccount(ba)), ["stop"]),
            density: "compact",
            rounded: "xl",
            border: "",
            lines: "one"
          }, {
            append: _withCtx(() => [
              _createVNode(_component_v_btn_icon, {
                onClick: _withModifiers(($event: any) => (_ctx.selectBankAccount(ba)), ["stop"]),
                color: "primary",
                icon: 
                            ba.id === _ctx.bankAccountSelectedId
                                ? '$radio_button_checked'
                                : '$radio_button_unchecked'
                        
              }, null, 8, ["onClick", "icon"])
            ]),
            default: _withCtx(() => [
              _createVNode(_component_v_list_item_title, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.getBankAccountDisplayName(ba)), 1)
                ]),
                _: 2
              }, 1024),
              _createVNode(_component_v_list_item_subtitle, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(ba.iban), 1)
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1032, ["class", "onClick"]))
        }), 128))
      ]),
      _: 1
    })
  ]))
}